import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, InfoIcon, ExternalLinkIcon } from 'lucide-react';
export function VampDetail() {
  const {
    t
  } = useTranslation("analytics");
  const navigate = useNavigate();
  const [showFraudTooltip, setShowFraudTooltip] = useState(false);
  const [showCardTestingTooltip, setShowCardTestingTooltip] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return <div className="max-w-7xl mx-auto" data-id="element-2617" data-mp="12hgihhi0nlgr">
      {/* Breadcrumb */}
      <div className="mb-6" data-id="element-2618" data-mp="xncaqw0xf9em">
        <button onClick={() => navigate('/card-monitoring')} className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2619" data-mp="xmkdlgrol3m8">
          
          <ChevronLeftIcon size={16} data-id="element-2620" data-mp="1q57z2xalaknu" />
          <span data-id="element-2621" data-mp="1q69ax3zfjb6m">{t("pages.CardMonitoringPrograms.card_monitoring_programs")}</span>
        </button>
      </div>

      {/* Header */}
      <div className="mb-8" data-id="element-2622" data-mp="22pdphbfc2k7c">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2623" data-mp="22q6n9mwbdzdc">
          {t("pages.CardMonitoringPrograms.visa_acquirer_monitoring_program_vamp")}
        </h1>
        <p className="text-gray-600" data-id="element-2624" data-mp="1szc26lut15th">
          {t("pages.VampDetail.view_your_monitoring_program_status_and")}
        </p>
      </div>

      {/* History Section */}
      <div className="mb-12" data-id="element-2625" data-mp="1xwkl4ons1dvs">
        <div className="flex items-center gap-2 mb-2" data-id="element-2626" data-mp="1j14lm44fgps0">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-2627" data-mp="1j0cylhowc0dc">{t("pages.VampDetail.history")}</h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2628" data-mp="1o10uago2l5dw">
            <InfoIcon size={16} data-id="element-2629" data-mp="1a0zpiq4opdt5" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-2630" data-mp="1a2sywd6omc4u">
          {t("pages.VampDetail.your_program_history_for_the_last")}
        </p>

        {/* History Table */}
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2631" data-mp="34fsjkkpx5wiz">
          <table className="w-full" data-id="element-2632" data-mp="39cizn81q4s4e">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-2633" data-mp="39bho72gsq3m5">
              <tr data-id="element-2634" data-mp="36zowr2lnzbss">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-2635" data-mp="3708g8nqyq88x">
                  {t("pages.VampDetail.program_type")}
                </th>
                {months.map(month => <th key={month} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-2636" data-mp="2y0bky3a2ib4w">
                  
                    {month}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2637" data-mp="3lo1xecvp5itm">
              {/* Fraud and disputes row */}
              <tr className="hover:bg-gray-50" data-id="element-2638" data-mp="3gwjtph2ah44y">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2639" data-mp="3gv8r3kkky2ff">
                  <div className="flex items-center gap-2" data-id="element-2640" data-mp="3bys1sn1n9i0r">
                    <span className="text-sm text-gray-900" data-id="element-2641" data-mp="3bw5u8ner72ij">
                      {t("pages.VampDetail.fraud_and_disputes")}
                    </span>
                    <div className="relative" data-id="element-2642" data-mp="8ghzj840gjbn">
                      <button onMouseEnter={() => setShowFraudTooltip(true)} onMouseLeave={() => setShowFraudTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-2643" data-mp="8fgqf96k26wk">
                        
                        <InfoIcon size={14} data-id="element-2644" data-mp="ktc7ovlxpg0y" />
                      </button>
                      {showFraudTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-2645" data-mp="psyn9bp8j8cx">
                          {t("pages.VampDetail.measures_fraud_and_disputes_against_the")}
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-2646" data-mp="13osln0sdufbs"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-2647" data-mp="1ig2l8wpwumf7" data-mpi={index}>
                    {index === 11 ? <div className="flex justify-center" data-id="element-2648" data-mp="1mgle8u3jhyiz">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-2649" data-mp="1mh4qbu6idsp3"></div>
                      </div> : <div className="flex justify-center" data-id="element-2650" data-mp="2f6wljiysav02">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-2651" data-mp="2f6eh3z1yxah2"></div>
                      </div>}
                  </td>)}
              </tr>

              {/* Card testing row */}
              <tr className="hover:bg-gray-50" data-id="element-2652" data-mp="2owzoobzmdpc4">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2653" data-mp="216ltwdpnhcdu">
                  <div className="flex items-center gap-2" data-id="element-2654" data-mp="2175e612rwcv1">
                    <span className="text-sm text-gray-900" data-id="element-2655" data-mp="1w8kcrybsbn50">{t("pages.VampDetail.card_testing")}</span>
                    <div className="relative" data-id="element-2656" data-mp="2a7tp2mwvdx3p">
                      <button onMouseEnter={() => setShowCardTestingTooltip(true)} onMouseLeave={() => setShowCardTestingTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-2657" data-mp="2a5h37ynzr2ld">
                        
                        <InfoIcon size={14} data-id="element-2658" data-mp="3lojo9m2vlont" />
                      </button>
                      {showCardTestingTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-2659" data-mp="3p4nynmqig3sz">
                          {t("pages.VampDetail.measures_card_testing_against_the_total")}
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-2660" data-mp="3f8b6wuej000v"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-2661" data-mp="gp4av38lzdlb" data-mpi={index}>
                    {index === 11 ? <div className="flex justify-center" data-id="element-2662" data-mp="20gjl95spq16">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-2663" data-mp="1xuah539b2gu"></div>
                      </div> : <div className="flex justify-center" data-id="element-2664" data-mp="uovrzcuf9a3j">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-2665" data-mp="umj3egu5s1hi"></div>
                      </div>}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Historical and current program status */}
      <div className="mb-12" data-id="element-2666" data-mp="14d9it7a47ita">
        <div className="flex items-center gap-2 mb-2" data-id="element-2667" data-mp="14d14daycg5fz">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-2668" data-mp="zclq8h68mtwy">
            {t("pages.VampDetail.historical_and_current_program_status")}
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2669" data-mp="vdmgmj9ka8z6">
            <InfoIcon size={16} data-id="element-2670" data-mp="qdi6daz8yahe" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-2671" data-mp="lm06kq8ymfy0">
          {t("pages.VampDetail.visaidentified_fraud_and_disputes_against_the")}
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-2672" data-mp="gn6tgyxl4qyd">
          <p className="text-center text-gray-500" data-id="element-2673" data-mp="boc1p7hn3s24">{t("pages.VampDetail.no_past_history_found")}</p>
        </div>
      </div>

      {/* Estimated program status */}
      <div className="mb-12" data-id="element-2674" data-mp="2mw1fskjh6bm">
        <div className="flex items-center gap-2 mb-2" data-id="element-2675" data-mp="2mm93yc0un2r">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-2676" data-mp="2oyyuxo0u1qd">
            {t("pages.VampDetail.estimated_program_status")}
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2677" data-mp="2j8svmr8q9i0y">
            <InfoIcon size={16} data-id="element-2678" data-mp="2jb5f58u4w0g4" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-2679" data-mp="2nbfjyi66wkte">
          {t("pages.VampDetail.pomelos_estimate_of_your_visa_frauds")}{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-2680" data-mp="2s7mrugi5c6dz">
            {t("pages.CardMonitoringPrograms.learn_more")}
          </a>{' '}
          {t("pages.VampDetail.about_how_to_keep_your_disputes")}
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-2681" data-mp="24jwgybc616rd">
          <p className="text-center text-gray-500" data-id="element-2682" data-mp="29b4qd7dhws4j">{t("pages.VampDetail.no_past_history_found")}</p>
        </div>
      </div>

      {/* Resources */}
      <div data-id="element-2683" data-mp="1buzar6l8b0ez">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2684" data-mp="1bv7muw9j21p4">{t("components.ResourcesSidebar.resources")}</h2>
        <div className="flex flex-wrap gap-4" data-id="element-2685" data-mp="1gsr1vye1uii4">
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2686" data-mp="a6q0hrng8hgw">
            
            <ExternalLinkIcon size={14} data-id="element-2687" data-mp="59ge6kvcwlxa" />
            {t("pages.VampDetail.program_overview")}
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2688" data-mp="j8z92bz5q0rn">
            
            <ExternalLinkIcon size={14} data-id="element-2689" data-mp="f5b1htaiz56e" />
            {t("pages.VampDetail.preventing_fraud_and_disputes")}
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2690" data-mp="t40yl8xch4ur">
            
            <ExternalLinkIcon size={14} data-id="element-2691" data-mp="12w6yd4tu8qki" />
            {t("pages.VampDetail.preventing_card_testing")}
          </a>
        </div>
      </div>
    </div>;
}